import { useState } from "react";
import { Plus } from "lucide-react";
import { FAQS } from "@/components/landing/landing-data";

/** Accordion. Closed answers stay in the DOM (hidden), so the copy is still in the page. */
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" aria-labelledby="lp-faq-title" className="relative pb-20 pt-14 md:pb-[110px] md:pt-[70px]">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 px-4 sm:px-8 lg:grid-cols-[360px_minmax(0,1fr)] lg:gap-20 lg:px-12">
        <div className="flex flex-col gap-4">
          <p className="lp-eyebrow">Before you ask</p>
          <h2 id="lp-faq-title" className="lp-h2">
            The real&nbsp;questions.
          </h2>
        </div>

        <div className="border-b border-black/10">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="border-t border-black/10">
                <h3 className="m-0">
                  <button
                    type="button"
                    id={`lp-faq-q-${i}`}
                    aria-expanded={isOpen}
                    aria-controls={`lp-faq-a-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex min-h-11 w-full items-center justify-between gap-6 py-5 text-left text-lg font-medium text-(--lp-ink) sm:py-[26px] sm:text-[22px]"
                  >
                    {f.q}
                    <span className="lp-plus" aria-hidden>
                      <Plus className="h-4 w-4" />
                    </span>
                  </button>
                </h3>
                <div
                  id={`lp-faq-a-${i}`}
                  role="region"
                  aria-labelledby={`lp-faq-q-${i}`}
                  hidden={!isOpen}
                >
                  <p className="-mt-1.5 mb-[26px] max-w-[660px] text-base leading-[1.6] text-(--lp-muted) sm:text-lg">
                    {f.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
